define(function (require) {

    var TableViewController = require('web-agent-framework/TableViewController');
    var CategoriesViewController = require('web-agent-viewControllers/CategoriesViewController');
    var WidgetStateBase = require('web-agent-widgets/WidgetStateBase');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');
    var SearchInputViewController = require('web-agent-viewControllers/SearchInputViewController');

    var BaseCategoriesWidget = WidgetStateBase.extend({
        ControllerName: "BaseCategoriesWidget",
        applicationType: "BaseCategoriesWidget",

        LPViewMap: {
            sectionWrapper: ".lpview_section_wrapper",
            rowWrapper: ".lpview_row_wrapper",
            contentPlaceholder: ".lpview_widget_content_placeholder"
        },

        LPViewClasses: {
            selected: "selected"
        },

        LPClassesMap: {
            search: "search"
        },

        initialize: function () {

        },

        events: function () {
        },

        render: function () {
        }
    });

    BaseCategoriesWidget.prototype.onSelectedVisitorChanged = function (newVisitorId) {
        if (this.visitorId !== newVisitorId) {
            this.unbindEvents();
            this.visitorId = newVisitorId;
            this.bindEvents();
        }
    };


    BaseCategoriesWidget.prototype.getConfiguration = function () {
        var configuration = {
            templateFile: "LP_categories_widget.html",
            rowTemplateFile: "LP_visitor_info_row.html",
            sectionTemplateFile: "LP_categories_widget_section.html",
            noDataTemplateFile: "LP_recommended_content_no_data.html"
        };
        return configuration;
    };

    BaseCategoriesWidget.prototype.initWidgetConfig = function () {
        this.widgetDataConfig = this.configuration.widgetDataConfig;
        if (typeof this.configuration.search !== "undefined") {
            this.search = this.configuration.search;
        } else {
            this.search = this.widgetDataConfig && this.widgetDataConfig.search;
        }
    };

    BaseCategoriesWidget.prototype.initView = function () {
        WidgetStateBase.prototype.initView.call(this);
        this.initWidgetConfig();

        var tableConfig = {
            modelController: this.modelController,
            ignoreSectionHover: true,
            modelPath: this.configuration.modelPath,
            modelData: this.configuration.modelData,
            rowTemplateFile: this.configuration.rowTemplateFile,
            sectionTemplateFile: this.configuration.sectionTemplateFile,
            noDataTemplate: this.configuration.noDataTemplateFile,
            dataBinder: this.configuration.dataBinder || this.dataBinder,
            dataRenderer: this.configuration.dataRenderer,
            context: this.configuration.context,
            disableSectionsDuringFilter: false,
            sectionOwnerIdTag: this.configuration.sectionOwnerIdTag
        };

        this.categoriesView = new CategoriesViewController({
            modelController: this.modelController,
            tableConfig: tableConfig,
            search: this.search
        });

        this.addViewController({viewController : this.categoriesView, target: this.LPViewMap.contentPlaceholder});

        // this is for legacy support. to not brake all other controllers based on exposing of the table and search views.
        this.categoriesTable = this.categoriesView.categoriesTable;
        this.searchInputView = this.categoriesView.searchInputView;

    };

    /**
     * This is the callback function for SearchInputViewController. we use it to clear the table's filter if clear button clicked.
     */
    BaseCategoriesWidget.prototype.clearSearch = function () {
        this.categoriesView.clearSearch();
    };

    BaseCategoriesWidget.prototype.updateModelData = function (modelData) {
        if (this.categoriesTable) {
            this.categoriesTable.updateModelData(modelData);
        }
    };

// TODO: move to categories controller.

    BaseCategoriesWidget.prototype.dataBinder = {
        rowClicked: function (data, rowView) {
            if (data.isSection) {
                this.toggleCategory(data, rowView);
            }
            else {
                this.toggleRow(data, rowView);
            }
        }
    };

    BaseCategoriesWidget.prototype.dataRenderer = {
        dataForSection: function (data, sectionIndex) {
            var value = {};
            if (data[sectionIndex].expandedByDefault) {
                value.selected = true;
            }
            return value;
        }
    };

    BaseCategoriesWidget.prototype.toggleCategory = function (data, categoryView) {
        var titleView = this.getFirstElement(this.LPViewMap.sectionWrapper, categoryView);
        if (data.expanded) {
            this.addClass(titleView, this.LPViewClasses.selected);
        } else {
            this.removeClass(titleView, this.LPViewClasses.selected);
        }
    };

    BaseCategoriesWidget.prototype.toggleRow = function (data, categoryView) {};

    return BaseCategoriesWidget;

});
